import { AsyncEvent } from 'ts-events';
export class StateService {
    $interval;
    log;
    evtConnectionBuildupStateChange = new AsyncEvent();
    evtGlobalConnectionStateChange = new AsyncEvent();
    evtUnreadCountChange = new AsyncEvent();
    signalingConnectionState;
    taskConnectionState;
    connectionBuildupState;
    progress = 0;
    progressInterval = null;
    slowConnect = false;
    stage;
    _state;
    attempt = 0;
    _unreadCount = 0;
    static $inject = ['$interval', 'LogService'];
    constructor($interval, logService) {
        this.$interval = $interval;
        this.log = logService.getLogger('State-S', 'color: #fff; background-color: #cc9900');
        this.reset();
    }
    get state() {
        return this._state;
    }
    set state(state) {
        const prevState = this._state;
        if (prevState === state) {
            return;
        }
        this._state = state;
        this.evtGlobalConnectionStateChange.post({ state: state, prevState: prevState });
    }
    updateSignalingConnectionState(state, chosenTask, handoverDone) {
        const prevState = this.signalingConnectionState;
        this.signalingConnectionState = state;
        if (!handoverDone) {
            this.log.debug('Signaling connection state:', prevState, '=>', state);
            switch (state) {
                case 'new':
                case 'ws-connecting':
                case 'server-handshake':
                case 'peer-handshake':
                    this.state = "warning";
                    break;
                case 'task':
                    this.stage = 1;
                    if (chosenTask === "relayed-data") {
                        this.updateTaskConnectionState("connected");
                    }
                    else {
                        this.state = "warning";
                    }
                    break;
                case 'closing':
                case 'closed':
                    this.state = "error";
                    break;
                default:
                    this.log.warn(`Unknown signaling connection state: ${state}`);
            }
        }
        else {
            this.log.debug('Ignored signaling connection state to "' + state + '"');
        }
    }
    updateTaskConnectionState(state) {
        const prevState = this.taskConnectionState;
        this.taskConnectionState = state;
        if (this.stage === 1) {
            this.log.debug('Task connection state:', prevState, '=>', state);
            switch (state) {
                case "new":
                case "connecting":
                case "reconnecting":
                    this.state = "warning";
                    break;
                case "connected":
                    this.state = "ok";
                    this.attempt = 0;
                    break;
                case "disconnected":
                    this.state = "error";
                    break;
                default:
                    this.log.warn('Ignored task connection state change to "' + state + '"');
            }
        }
        else {
            this.log.debug('Ignored task connection state change to "' + state + '"');
        }
    }
    updateConnectionBuildupState(state) {
        if (this.connectionBuildupState === state) {
            return;
        }
        const prevState = this.connectionBuildupState;
        this.log.debug('Connection buildup state:', prevState, '=>', state);
        this.connectionBuildupState = state;
        this.evtConnectionBuildupStateChange.post({ state: state, prevState: prevState });
        if (this.progressInterval !== null) {
            this.$interval.cancel(this.progressInterval);
            this.progressInterval = null;
        }
        this.slowConnect = false;
        switch (state) {
            case 'new':
                this.progress = 0;
                break;
            case 'push':
                this.progress = 0;
                this.progressInterval = this.$interval(() => {
                    if (this.progress < 12) {
                        this.progress += 1;
                    }
                    else {
                        this.slowConnect = true;
                    }
                }, 800);
                break;
            case 'manual_start':
                this.progress = 0;
                break;
            case 'connecting':
                this.progress = 13;
                break;
            case 'waiting':
                this.progress = 14;
                break;
            case 'peer_handshake':
                this.progress = 15;
                this.progressInterval = this.$interval(() => {
                    if (this.progress < 40) {
                        this.progress += 5;
                    }
                    else if (this.progress < 55) {
                        this.progress += 3;
                    }
                    else if (this.progress < 60) {
                        this.progress += 1;
                    }
                    else {
                        this.slowConnect = true;
                    }
                }, 500);
                break;
            case 'loading':
                this.progress = 60;
                this.progressInterval = this.$interval(() => {
                    if (this.progress < 80) {
                        this.progress += 4;
                    }
                    else if (this.progress < 90) {
                        this.progress += 2;
                    }
                    else if (this.progress < 99) {
                        this.progress += 1;
                    }
                    else {
                        this.slowConnect = true;
                    }
                }, 600);
                break;
            case 'done':
                this.progress = 100;
                break;
            default:
                this.progress = 0;
                break;
        }
    }
    readyToSubmit(chosenTask, startupDone) {
        switch (chosenTask) {
            case "relayed-data":
                return true;
            case "webrtc":
            default:
                return this.state === "ok" && startupDone;
        }
    }
    get unreadCount() {
        return this._unreadCount;
    }
    set unreadCount(count) {
        if (this._unreadCount === count) {
            return;
        }
        this._unreadCount = count;
        this.evtUnreadCountChange.post(count);
    }
    reset(connectionBuildupState = 'new', shouldResetUnreadCount = true) {
        this.log.debug('Reset states');
        this.signalingConnectionState = 'new';
        this.taskConnectionState = "new";
        this.stage = 0;
        this.state = "error";
        this.connectionBuildupState = connectionBuildupState;
        this.progress = 0;
        if (shouldResetUnreadCount) {
            this.unreadCount = 0;
        }
    }
}
